import { React } from "react";
import {
	ListItemText,
	ListItem,
	ListItemIcon,
	ListItemButton,
	Box,
} from "@mui/material";
import "./CategoryList.scss";
import { useTranslation } from "react-i18next";

export default function SubcategoryList({
	category,
	subcategory,
	transactions,
	setSelectedCategory,
	selectedSubcategory,
	setSelectedSubcategory,
}) {
	const userCurrency = localStorage.getItem("userCurrency");
	const { t } = useTranslation();
	const getTransactionsAmount = () => {
		const amount = transactions.reduce(
			(sum, item) =>
				item.includeInAnalysis
					? sum + item.amount * item.exchangeRate
					: sum,
			0
		);
		return parseFloat(amount.toFixed(2));
	};

	const handleSelectSubcategory = (event) => {
		event.stopPropagation();
		if (selectedSubcategory === subcategory) {
			setSelectedSubcategory(null);
			setSelectedCategory(null);
		} else {
			setSelectedSubcategory(subcategory);
			setSelectedCategory(category);
		}
	};

	return (
		<>
			<ListItem sx={{ pl: 2, pt: 0, pb: 0 }} key={subcategory._id}>
				<ListItemButton
					sx={{ py: 0, borderRadius: "10px" }}
					onClick={(event) => handleSelectSubcategory(event)}
				>
					<Box
						sx={{
							display: "flex",
							justifyContent: "space-between",
							alignItems: "center",
							width: "100%",
						}}
					>
						<Box
							sx={{
								display: "flex",
								alignItems: "center",
							}}
						>
							<ListItemIcon
								sx={{
									cursor: "pointer",
									color: "inherit",
									minWidth: "auto",
									mr: 1,
								}}
							>
								{subcategory.emoji ?? (
									<span
										style={{
											fontSize: 22,
											color: "null",
										}}
									>
										{subcategory.emoji}
									</span>
								)}
							</ListItemIcon>
							<ListItemText
								primary={
									subcategory.name
										? subcategory.name
										: t(subcategory.translationKey)
								}
							/>
						</Box>
						<Box>
							<ListItemText
								primary={`${getTransactionsAmount().toFixed(2).toLocaleString()} ${userCurrency}`}
								primaryTypographyProps={{
									fontSize: "15px",
									fontWeight: "bold",
								}}
							/>
						</Box>
					</Box>
				</ListItemButton>
			</ListItem>
		</>
	);
}
